import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Always default to light mode for enterprise professional look
  const [theme, setTheme] = useState(() => {
    // Clear any saved dark theme preference - force light mode
    localStorage.setItem('docudefender-theme', 'light');
    return 'light';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    
    // Remove both classes first
    root.classList.remove('light', 'dark');
    
    // Always add light class for professional enterprise look
    root.classList.add('light');
    
    // Save to localStorage
    localStorage.setItem('docudefender-theme', 'light');
  }, [theme]);

  // Disable system theme changes - always use light mode
  useEffect(() => {
    // No-op: We don't want to change theme based on system preferences
  }, []);

  const toggleTheme = () => {
    // Disabled - always light mode
    // setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const value = {
    theme: 'light', // Always light
    setTheme: () => {}, // No-op
    toggleTheme,
    isDark: false, // Always false
    isLight: true, // Always true
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
